import React from 'react';
import i18n from '../../i18n';
import { Box, IconButton, TableCell, Tooltip, Typography } from '@mui/material';
import { ContentCopy } from '@mui/icons-material';

const styles = {
    controllerCell: {
        backgroundColor: '#F4F6F8',
        fontWeight: 'bold'
    },
    truncatedText: {
        cursor: 'pointer',
        overflow: 'hidden',
        userSelect: 'text',
        display: 'inline-block'
    }
};

export default class GridTextCell extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            expanded: false,
            isMobile: false
        };
    }
    componentDidMount() {
        const mql = window.matchMedia('(max-width:600px)');
        this.setState({ isMobile: mql.matches });
    }

    toggleExpand = () => {
        this.setState((prev) => ({ expanded: !prev.expanded }));
    };

    copyValueToClipboard = () => {
        const { show } = this.props.field;
        const rawValue = show ? this.props.value?.[show] : this.props.value;
        const value =
            rawValue !== undefined && rawValue !== null ? String(rawValue) : '';
        navigator.clipboard.writeText(value);
    };

    render() {
        const { row, field } = this.props;
        const { id, translate, needStyle, show, showCopyButton } =
            this.props.field;
        const rawValue = show ? this.props.value?.[show] : this.props.value;
        const value = translate ? i18n.t(`${translate}.${rawValue}`) : rawValue;
        const { expanded, isMobile } = this.state;

        const isLong = typeof value === 'string' && value.length > 36;
        const shouldTruncate = isLong && !isMobile && !expanded;
        const displayText = shouldTruncate ? value.slice(0, 36) + '...' : value;

        const extra =
            typeof field.extraRender === 'function'
                ? field.extraRender(value, row)
                : null;
        const enableCopyExtraRender = field.enableCopyExtraRender;

        const textComponent = (
            <Box
                sx={{
                    maxWidth: '100%',
                    cursor: isLong && !isMobile ? 'pointer' : 'default'
                }}
                onClick={isLong && !isMobile ? this.toggleExpand : undefined}
            >
                <Typography
                    variant="body2"
                    sx={shouldTruncate ? styles.truncatedText : undefined}
                >
                    {displayText}
                </Typography>

                {showCopyButton && displayText && (
                    <IconButton
                        size="small"
                        onClick={(e) => {
                            e.stopPropagation();
                            this.copyValueToClipboard();
                        }}
                        sx={{
                            "ml": 0.5,
                            "width": 16,
                            "height": 16,
                            "color": 'text.secondary',
                            '& svg': { fontSize: '1rem' }
                        }}
                    >
                        <ContentCopy fontSize="inherit" />
                    </IconButton>
                )}
                {extra && (
                    <p>
                        {extra}
                        {enableCopyExtraRender && (
                            <IconButton
                                size="small"
                                onClick={() =>
                                    navigator.clipboard.writeText(extra)
                                }
                                sx={{
                                    "padding": '0 0 0 2px',
                                    "width": '16px',
                                    "height": '16px',
                                    "color": 'text.secondary',
                                    '& svg': { fontSize: '1rem' }
                                }}
                            >
                                <ContentCopy fontSize="inherit" />
                            </IconButton>
                        )}
                    </p>
                )}
            </Box>
        );
        const baseStyle = this.props.styles;

        return (
            <TableCell
                key={id}
                align="left"
                sx={{
                    ...(needStyle ? styles.controllerCell : {}),
                    ...baseStyle
                }}
            >
                {isLong && !expanded ? (
                    <Tooltip title={value}>{textComponent}</Tooltip>
                ) : (
                    textComponent
                )}
            </TableCell>
        );
    }
}
